import React from 'react'
import { Accordion } from '@paypalcorp/pp-react'

const ContentAccordion = ({ children }: any) => {
  return (
    <Accordion
      name="contentAccordion"
      theme="v2"
      className="paypalContent-accordion"
    >
      {children}
    </Accordion>
  )
}

export default ContentAccordion
